import React from 'react'

import DetailsSummarySection from '../../../components/details/summary/DetailsSummarySection'

export default function NoEffectiveVisitSummarySection({ summaryFields = [], extraFields = [] }) {
  return (
    <DetailsSummarySection
      summaryFields={summaryFields}
      extraFields={extraFields}
      summaryTitle="DETALLES DE LA VISITA"
      summaryOpenLabel="Abrir detalles de la visita"
      summaryCloseLabel="Cerrar detalles de la visita"
    />
  )
}
